
import "./App.css";
import React from 'react';
import ProjectRoutes from "./Components/ProjectRoutes/ProjectRoutes";

import 'react-toastify/dist/ReactToastify.css';
import { ToastContainer } from "react-toastify";
function App() {
  document.title = 'Sare';
  return (

    <div>
      <ToastContainer />
      <ProjectRoutes />
    </div>

  );
}

export default App;
